module.exports = __webpack_public_path__ + "pictures.png";